// extracted by mini-css-extract-plugin
export default {"root":"CreateDocument_root__2NnRd"};